import { useContext, useRef, useState } from 'react';
import { UserContext } from '../../../Contexts/UserContext';
import { Button } from '@nxtvid/component-library';
import { handleSendUserPromptToRFPAgent } from '../services/handleSendUserPromptToRFPAgent';
import { useAutoResizeTextarea } from '../hooks/useAutoResizeTextarea';

export const ChatInput = ({ chatSessionRef, setChatSession}) =>{
    const textAreaRef = useRef(null);
    const containerRef = useRef(null);
    const {userInfo} = useContext(UserContext)
    const [userMessage, setUserMessage] = useState('')

    const sendIcon = require('../../../Images/send-icon.png')
    useAutoResizeTextarea(textAreaRef, userMessage, containerRef);
    return(
        <div ref={containerRef} className = "chat-input-container">
                            <textarea rows={1} ref={textAreaRef} className="chat-input" placeholder="Type a message..." value={userMessage} onChange={(e)=>setUserMessage(e.target.value)}/>
                            <div className="send-message-to-RFP-agent-container">
                            <Button label = 'Send' className = 'send-message-to-RFP-agent-button' size = 'small' type = 'primary' icon = {sendIcon} onClick={()=>handleSendUserPromptToRFPAgent(userMessage, chatSessionRef, setChatSession, setUserMessage, containerRef, textAreaRef, userInfo)}/>
                            </div>
                        </div>
    )
}